import type { PermissionName, ZgriPermissionName } from './permission.types';

import { hasUserPermission, permissionIsNotSet } from './permissions.util';
import { useUser } from './useUser';

type UserPermission = {
  notSet: boolean;
  enabled: boolean;
};

export const usePermission = (permissionName: PermissionName): UserPermission => {
  const { isPublic, user } = useUser();

  if (isPublic) return { notSet: false, enabled: false };

  if (!user?.userPermissions) return { notSet: false, enabled: false };

  const isPermissionNotSet = permissionIsNotSet(permissionName, user.userPermissions);

  if (isPermissionNotSet) return { notSet: true, enabled: false };

  return { notSet: false, enabled: hasUserPermission(permissionName, user.userPermissions) };
};

export const useZgriPermission = (permissionName: ZgriPermissionName): UserPermission => {
  return usePermission(permissionName);
};
